import React from 'react';
import queryString from 'query-string';
import PropTypes from 'prop-types';

import { Twitter } from 'components/icons';

const TwitterShare = ({ product, className }, { testId }) => {
  const twitterLink = `https://twitter.com/share?${queryString.stringify({ text: product.name, url: product.link })}`;

  return (
    <a
      href={twitterLink}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Share on Twitter"
      data-te="TE_PDP_SHARETWITTER"
      data-test-id={testId('twitterShareIcon')}>
      <Twitter size={22}/>
    </a>
  );
};

TwitterShare.contextTypes = {
  testId: PropTypes.func.isRequired
};

export default TwitterShare;
